/* Page collection : tiroir de filtres et tri immédiat. */

(function initCollection() {
  /* --- Tri : la sélection recharge la liste sans bouton de validation --- */
  const sortSelect = document.querySelector('[data-sirito-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      // Un tri renvoie forcément sur le début de la liste.
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* --- Tiroir de filtres --- */
  const drawer = document.getElementById('SiritoFilters');
  const toggle = document.querySelector('[data-sirito-filters-toggle]');
  if (!drawer || !toggle) return;

  const panel = drawer.querySelector('.sirito-filters__panel');
  let lastFocused = null;

  const open = () => {
    lastFocused = document.activeElement;
    drawer.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    const first = panel.querySelector('button, input, a');
    if (first) first.focus();
  };

  const close = () => {
    drawer.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  };

  toggle.addEventListener('click', open);
  drawer.querySelectorAll('[data-sirito-filters-close]').forEach((el) => el.addEventListener('click', close));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !drawer.hidden) close();
  });

  // Le focus reste dans le tiroir tant qu'il est ouvert.
  drawer.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab' || drawer.hidden) return;
    const focusables = panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* --- Envoi des filtres : on ne garde que les champs réellement remplis
         pour éviter une adresse encombrée de paramètres vides. --- */
  const form = document.getElementById('SiritoFacetForm');
  if (!form) return;

  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const params = new URLSearchParams();

    form.querySelectorAll('input[type="checkbox"]:checked').forEach((input) => {
      params.append(input.name, input.value);
    });

    form.querySelectorAll('input[type="number"]').forEach((input) => {
      if (input.value !== '') params.append(input.name, input.value);
    });

    const sort = form.querySelector('input[name="sort_by"]');
    if (sort && sort.value) params.append('sort_by', sort.value);

    const base = window.location.pathname;
    const query = params.toString();
    window.location.href = query ? `${base}?${query}` : base;
  });
})();
